import { computed, Ref } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { CommonResType } from '@/types/commonApiType';

import { api } from './_http';

//구독내역
type GetMemberSubscriptionDataType = Ref<{ state: string; page: number | string; row: number | string }>;
type GetMemberSubscriptionListType = {
	subscription_pk: number;
	subscription_goods_name: string;
	subscription_start_date: string;
	subscription_end_date: string;
};
type GetMemberSubscriptionResType = {
	data: { subscription_ing_cnt: number; subscription_ing: GetMemberSubscriptionListType[] };
	success: true;
};
type GetMemberSubscriptionExpResType = {
	data: { subscription_exp_cnt: number; subscription_exp: GetMemberSubscriptionListType[] };
	success: true;
};
export const useGetMemberSubscriptionApi = (params: GetMemberSubscriptionDataType) => {
	const url = computed(() => {
		return '/v1/front/getMemberSubscription';
	});
	return useQuery<AxiosResponse, AxiosError, GetMemberSubscriptionResType & GetMemberSubscriptionExpResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url.value, params.value),
		select: (res) => res.data,
	});
};
//구독 결제 내역- 구독 정보 확인
type GetMemberSubscriptionDetailParamsType = Ref<{
	subscription_pk: number;
}>;
type master_name = {
	master_name: string;
};
type pay_info_recent = {
	member_pk: number;
	pay_info_cancel_date: string;
	pay_info_card_approval_no: string;
	pay_info_card_company_name: string;
	pay_info_card_company_no: string;
	pay_info_card_no: string;
	pay_info_clause: string;
	pay_info_date: string;
	pay_info_goods_name: string;
	pay_info_goods_price: string;
	pay_info_member_name: string;
	pay_info_next_pay_date: string;
	pay_info_order_no: string;
	pay_info_pay_key: string;
	pay_info_pk: number;
	pay_info_quota_month: string;
	pay_info_result_code: string;
	pay_info_state: string;
	pay_info_time: string;
	pay_info_transaction_no: string;
	pay_info_datetime: string;
	subscription_pk: string;
};

type subscription_detail = {
	pay_info_card_company_name: string;
	pay_info_card_no: string;
	pay_info_date: string;
	pay_info_goods_name: string;
	pay_info_goods_price: number;
	pay_info_next_pay_date: string;
	pay_info_time: string;
	subscription_end_date: string;
	subscription_enrollment_date: string;
	subscription_maintain_yn: number;
	subscription_master_key: string;
	subscription_pk: number;
	subscription_start_date: string;
};
export type GetMemberSubscriptionDetailResType = {
	master_name: master_name[];
	pay_info_recent?: pay_info_recent[];
	subscription_detail: subscription_detail;
};
export const useGetMemberSubscriptionDetailApi = (params: GetMemberSubscriptionDetailParamsType) => {
	const url = '/v1/front/getMemberSubscriptionDetail';
	return useQuery<AxiosResponse, AxiosError, GetMemberSubscriptionDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, { ...params.value }),
		select: (res) => res.data?.data,
		enabled: false,
	});
};

//구독 결제 내역 조회
type GetMemberSubscriptionDetailMoreDataType = Ref<{
	subscription_pk?: string | number;
	page: number | string;
	view: number | string;
}>;
type GetMemberSubscriptionDetailMoreListType = {
	pay_info_card_company_name: number;
	pay_info_cancel_date: string;
	pay_info_card_aster: string;
	pay_datetime: string;
	pay_info_goods_price: string;
};
type GetMemberSubscriptionDetailMoreResType = {
	pay_info_cnt: number;
	pay_info: GetMemberSubscriptionDetailMoreListType[];
};
export const useGetMemberSubscriptionDetailMoreApi = (params: GetMemberSubscriptionDetailMoreDataType) => {
	const url = '/v1/front/getMemberSubscriptionDetailMore';
	return useQuery<AxiosResponse, AxiosError, GetMemberSubscriptionDetailMoreResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data.data,
	});
};

//내정보조회
type GetMypageMyType = {
	member_contact: string;
	member_id: string;
	member_name: string;
	member_nickname: string;
	member_pk: number;
	member_push_agree: number;
	member_push_agree_date: string;
};
type GetMypageMyResType = {
	member: GetMypageMyType;
};
export const useMypageGetMyDataApi = () => {
	const url = '/v1/front/mypageGetMyData';
	return useQuery<AxiosResponse, AxiosError, GetMypageMyResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};

// 내 정보 수정
type ModifyMemberInfoDataType = {
	member_push_agree: boolean;
	member_nickname: string;
};
type ModifyMemberInfoResType = CommonResType;
export const useModifyMemberInfoApi = () => {
	const url = '/v1/front/modifyMemberInfo';
	return useMutation<AxiosResponse<ModifyMemberInfoResType>, AxiosError, ModifyMemberInfoDataType>({
		mutationFn: (data: ModifyMemberInfoDataType) => api.post(url, data),
	});
};

// 내 정보 수정 - 휴대폰 번호 변경
type ModifyMemberPhoneDataType = {
	phonenum: string;
	identification_no: string;
};
type ModifyMemberPhoneResType = CommonResType;
export const useModifyMemberPhoneApi = () => {
	const url = '/v1/front/modifyMemberPhone';
	return useMutation<AxiosResponse<ModifyMemberPhoneResType>, AxiosError, ModifyMemberPhoneDataType>({
		mutationFn: (data: ModifyMemberPhoneDataType) => api.post(url, data),
	});
};

// 내 정보 수정 - 회원탈퇴

type QuitMemberResType = CommonResType;
export const useQuitMemberApi = () => {
	const url = '/v1/front/quitMember';
	return useMutation<AxiosResponse<QuitMemberResType>, AxiosError>({
		mutationFn: () => api.post(url),
	});
};

// 회원 구독취소
type MemberUnsubscribeDataType = {
	subscription_pk: number;
};
type MemberUnsubscribeResType = CommonResType;
export const useMemberUnsubscribeApi = () => {
	const url = '/v1/front/memberUnsubscribe';
	return useMutation<AxiosResponse<MemberUnsubscribeResType>, AxiosError, MemberUnsubscribeDataType>({
		mutationFn: (data: MemberUnsubscribeDataType) => api.post(url, data),
	});
};

// 마이페이지- 비밀번호 확인
type MypageCheckPasswordDataType = {
	member_password: string;
};
type MypageCheckPasswordResType = CommonResType;
export const useMypageCheckPasswordApi = () => {
	const url = '/v1/front/mypageCheckPassword';
	return useMutation<AxiosResponse<MypageCheckPasswordResType>, AxiosError, MypageCheckPasswordDataType>({
		mutationFn: (data: MypageCheckPasswordDataType) => api.post(url, data),
	});
};

// 마이페이지- 비밀번호 수정
type MypageModifyPasswordDataType = {
	member_password: string;
};
type MypageModifyPasswordResType = CommonResType;
export const useMypageModifyPasswordApi = () => {
	const url = '/v1/front/mypageModifyPassword';
	return useMutation<AxiosResponse<MypageModifyPasswordResType>, AxiosError, MypageModifyPasswordDataType>({
		mutationFn: (data: MypageModifyPasswordDataType) => api.post(url, data),
	});
};

// 서비스 이용약관
type GetTermsDataType = {
	tos_type: string;
};
type GetTermsListType = {
	tos_content: string;
	tos_enrollment_date: string;
	tos_modifying_date: string;
	tos_start_date: string;
	tos_type: string;
};
type GetTermsResType = {
	data: { terms: GetTermsListType };
	success: true;
};
export const useGetTermsApi = (params: GetTermsDataType) => {
	const url = '/v1/front/getTerms';
	return useQuery<AxiosResponse, AxiosError, GetTermsResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data,
	});
};

// 구독 해지 사유 조회
type GetUnsubscribeListDataType = {
	reasons: ReasonsType[];
};
type ReasonsType = {
	unsubscribe_pk: number;
	unsubscribe_sentence: string;
};
export const useGetUnsubscribeListApi = () => {
	const url = '/v1/front/getUnsubscribeList';
	return useQuery<AxiosResponse, AxiosError, GetUnsubscribeListDataType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};

// 구독 해지 사유 등록
type SaveUnsubscribeReasonsParamsType = {
	unsubscribe_pks: string;
	unsubscribe_app_contents: string;
	unsubscribe_etc_contents: string;
};
export const useSaveUnsubscribeReasonsApi = () => {
	const url = '/v1/front/saveUnsubscribeReasons';
	return useMutation<AxiosResponse<ModifyMemberInfoResType>, AxiosError, SaveUnsubscribeReasonsParamsType>({
		mutationFn: (data: SaveUnsubscribeReasonsParamsType) => api.post(url, data),
	});
};
